import { ReactNode, useState, useEffect } from 'react';
import { useAppDispatch } from '../store';
import { useSessionId } from '../hooks/useSessionId';

import { checkNewMessages } from '../services/messagesServices';
import { checkNewMessagesSuccess } from '../actions/messagesActions';

import Header from './header';
import Sidebar from './sidebar';
import Footer from './footer';

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  const dispatch = useAppDispatch();
  const sessionId = useSessionId();

  const checkMessages = () =>
    checkNewMessages(sessionId).then(([error, result]) => {
      if (!error && result) {
        const responseData = result.data;
        if (responseData?.hasNew !== undefined) {
          dispatch(checkNewMessagesSuccess(responseData.hasNew));
        }
      }
    });

  useEffect(() => {
    checkMessages();

    const checkMailInterval = setInterval(() => checkMessages(), 60000);

    return () => clearInterval(checkMailInterval);
  }, []);

  const toggleSidebar = () => setSidebarOpen((exist) => !exist);

  return (
    <div className="layout layout--base">
      <Header
        className="layout-header shadow"
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
      />
      <Sidebar className="layout-side" isOpen={isSidebarOpen} />
      <main className="layout-main">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
